var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAgendaPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 8v7h1V8h7V7H8V0H7v7H0v1h7Z",
  fill: "#C4C4C4"
})));
export { SvgAgendaPlus as ReactComponent };
export default __webpack_public_path__ + "0a5b2519deec54cb9c90ca8d25c2d0f1.svg";